<template>
  <v-responsive :aspect-ratio="aspectRatio" class="questions-section-header">
    <div class="questions-section-header__text">
      <div class="questions-section-header__header">Questions?</div>
      <v-btn color="white" class="v-btn--emphasis" link to="/support"
        >Visit Support Page</v-btn
      >
    </div>
  </v-responsive>
</template>
<script>
export default {
  computed: {
    aspectRatio() {
      const aspectRatio = {
        sm: 375 / 380,
        xs: 375 / 380
      };

      return aspectRatio[this.$size] || 1439 / 516;
    }
  }
};
</script>

<style lang="scss" scoped>
.questions-section-header {
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url("~@/assets/questions-bg.png");
  @media screen and (max-width: 960px) {
    background-image: url("~@/assets/questions-bg-mobile.png");
  }

  &__header {
    color: white;
    font-size: 36px;
    font-weight: 300;
    margin-bottom: 30px;
  }

  &__text {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
